/**
 * Created by Ivan on 10.03.2026
 */

const HungryGamesCooldownWindow = Prefab.createWindow("hungry_games_cooldown_window", "hungrygamescooldownwindow_prefab_json");
